import { useEffect, useState } from "react";
import styles from "./Billing.module.css";
import OverviewTab from "./OverviewTab";
import CreditsTab from "./CreditsTab";
import BillingTab from "./BillingTab";
import { JService, refreshAccessToken } from "../api-service/ApiService";
import AnimationPage from "../shared/animation-page/AnimationPage";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  saveAccountDetails,
  setSubscriptionDetails,
} from "../features/account/account";
import { reduxPersistSelectedVirtualNumber } from "../features/virtual-number/virtualNumber";
import { enqueueSnackbar } from "notistack";
import { getOrgURLParam } from "../../utility-functions";

const Billing = () => {

  const reduxAccount = useSelector((state) => state?.account?.value);

  const location = useLocation();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(
    location?.state?.tab || "Overview"
  );
  const [data, setData] = useState();
  const [tabs, setTabs] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const handleActiveTab = (tab) => {
    setActiveTab(tab);
  };
  const fetchData = (signal) => {
    setShowLoader(true);
    JService.get(
      `/api/v1/subscriptions/billing-details/${getOrgURLParam()}`,
      {},
      { signal }
    )
      .then((res) => {
        if (!("success" in res)) return;
        if (!res.success)
          throw new Error(
            res?.message || "Error in retrieving billing details"
          );
        setShowLoader(false);
        setData(res.data);
        let temp = { ...res?.data };
        delete temp["numbers"];
        temp["addon_licenses"] = [...temp?.addons];
        delete temp["addons"];
        temp["plan_licenses"] = { ...temp?.plan?.licenses };
        temp["viewer_licenses"] = { ...temp?.viewers?.licenses };
        if (temp && Object.keys(temp)?.length) {
          dispatch(setSubscriptionDetails(temp));
        }
      })
      .catch((err) => {
        setData({});
        setShowLoader(false);
        enqueueSnackbar(err?.message, { variant: "error" });
      });
    // .finally(()=>{
    //   setShowLoader(false)
    // })
  };
  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);

    return () => controller.abort();
  }, [reduxAccount?.selectedOrg]);

  useEffect(() => {
    if (!data) return;
    // if(data?.status==='TRIAL') setTabs(['Overview','Credits'])
    // else
    setTabs(["Overview", "Credits", "Billing"]);
    if (
      data.status === "ACTIVE" &&
      localStorage.getItem("account-upgraded-today") &&
      JSON.parse(localStorage.getItem("account-upgraded-today") == "false")
    ) {
      if (Date.now() - new Date(data?.start_date) < 86400000) {
        localStorage.setItem("account-upgraded-today", JSON.stringify(true));
      }
    }
  }, [data]);

  const handleUpdateAddonUsers = async (action, idList, addonName, addonData) => {
    let curIds = addonData?.users?.map((elem) => elem?.id);
    if (action === "remove") curIds = curIds?.filter((elem) => elem !== idList);
    else if (action === "add") curIds = [...curIds, ...idList];

    try {
      let res = await JService.post(
        `/api/v1/subscriptions/activate-addon/${getOrgURLParam()}`,
        JSON.stringify({ user_ids: curIds, addon: addonName })
      );
      if (!res?.success)
        throw new Error(
          res?.message || "Failed to activate addon for provided users"
        );

      let tokenRefreshed = await refreshAccessToken();

      let res2 = await JService.get("/api/v1/auth/retrieve-account-profile/");
      if (res2?.success) {
        dispatch(saveAccountDetails(res2));
        if (res2?.data?.profile?.primary_virtual_number) {
          dispatch(
            reduxPersistSelectedVirtualNumber(
              res2?.data?.profile?.primary_virtual_number
            )
          );
        }
        enqueueSnackbar(
          res?.message || "Succesfully activated addon for provided users",
          { variant: "success" }
        );
      }

      if (!tokenRefreshed) {
        enqueueSnackbar(
          "Please logout and log back in for changes to reflect",
          { variant: "error" }
        );
      }
    } catch (err) {
      enqueueSnackbar(err?.message || err?.response?.data?.message, {
        variant: "error",
      });
    } finally {
      setTimeout(() => {
        fetchData();
      }, 1000);
    }
  };

  return (
    <div
      className="screen-container"
      style={{
        paddingTop: "24px",
        paddingLeft: "0",
        height:
          document.documentElement.scrollHeight - 56 >= window.innerHeight
            ? "fit-content"
            : window.innerHeight,
      }}
    >
      <div className={styles.tabContainer}>
        <hr />
        {[
          tabs.map((tab, index) => {
            return (
              <p
                className={`${styles.tabLabel} ${tab === activeTab ? styles.selectedTabLabel : ""
                  } b2 regular-font`}
                key={index}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </p>
            );
          }),
        ]}
        <hr />
      </div>
      {showLoader && <AnimationPage />}
      {activeTab === "Overview" && !showLoader && (
        <OverviewTab
          activeTab={activeTab}
          changeActiveTab={handleActiveTab}
          paymentDueDate={data?.payment_due_date}
          currency={data?.plan?.name?.includes("INR") ? "₹" : "$"}
          status={data?.status}
          plan={data?.plan}
          viewers={data?.viewers}
          addons={data?.addons}
          endDate={data?.end_date}
          startDate={data?.start_date}
          numbers={data?.numbers}
          handleUpdateAddonUsers={handleUpdateAddonUsers}
          refetchData={fetchData}
        />
      )}
      {activeTab === "Credits" && !showLoader && (
        <CreditsTab activeTab={activeTab} setActiveTab={setActiveTab} />
      )}
      {activeTab === "Billing" && !showLoader && (
        <BillingTab
          activeTab={activeTab}
          billingAddress={data?.billing_address}
          billingContacts={data?.billing_contacts}
          billingNumberApi={data?.billing_number}
          gstin={data?.gstin}
          autoCharge={data?.auto_charge}
          refetchData={fetchData}
        />
      )}
    </div>
  );
};

export default Billing;
